import FreeSpinReel from "./FreeSpinReel";
export default class FreeSpinReelStatic extends FreeSpinReel {
    constructor(x, y, index, freeSpinCellCreation) {
        super(x, y, index, freeSpinCellCreation);
    }
}
